"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var lodash_1 = require("lodash");
var money_1 = require("../money");
var currency_1 = require("../currency");
var sanitized_render_1 = require("../components/sanitized_render");
var LOWBALL_NUDGE_THRESHOLD = 0.75;
var HIGHBALL_NUDGE_THRESHOLD = 1;
var NUDGE_DELAY = 800; // milliseconds
var OffersNudge = /** @class */ (function (_super) {
    tslib_1.__extends(OffersNudge, _super);
    function OffersNudge() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.debouncedUpdate = lodash_1.debounce(_this.forceUpdate, _this.props.delay);
        return _this;
    }
    OffersNudge.prototype.shouldComponentUpdate = function (nextProps) {
        if (this.props.delay === 0 || !nextProps.offerAmount) {
            return true;
        }
        this.debouncedUpdate();
        return false;
    };
    OffersNudge.prototype.componentWillUnmount = function () {
        this.debouncedUpdate.flush();
    };
    OffersNudge.prototype.render = function () {
        var _a = this.props, offerAmount = _a.offerAmount, originalAmount = _a.originalAmount;
        if (!offerAmount) {
            return null;
        }
        var _b = lodash_1.defaults(currency_1.default.get(this.props.currency), { symbol: '', displayCode: '' }), symbol = _b.symbol, displayCode = _b.displayCode;
        var offerAmountRatio = parseInt(offerAmount, 10) / parseInt(originalAmount, 10);
        var formattedAmount = money_1.formatNumber(parseInt(offerAmount, 10));
        var formattedAmountWithCurrency = ("" + symbol + formattedAmount + " " + displayCode).trim();
        if (offerAmountRatio < LOWBALL_NUDGE_THRESHOLD) {
            return (React.createElement("section", { className: "offers-nudge offers-nudge--lowball" },
                React.createElement("h1", { className: "offers-nudge__title" }, I18n.t('commons.offers.nudgeHeaderLowball')),
                React.createElement("p", { className: "offers-nudge__disclaimer" }, I18n.t('commons.offers.nudgeDisclaimerLowball'))));
        }
        if (offerAmountRatio > HIGHBALL_NUDGE_THRESHOLD) {
            return (React.createElement("section", { className: "offers-nudge offers-nudge--highball" },
                React.createElement("h1", { className: "offers-nudge__title" }, I18n.t('commons.offers.nudgeHeaderHighball')),
                React.createElement("p", { className: "offers-nudge__disclaimer" },
                    React.createElement(sanitized_render_1.default, { html: I18n.t('commons.offers.nudgeDisclaimerHighball', {
                            amount: formattedAmountWithCurrency,
                            tagOpen: '<span class="weight-bold">',
                            tagClose: '</span>',
                        }) }))));
        }
        return null;
    };
    OffersNudge.defaultProps = {
        delay: NUDGE_DELAY,
    };
    return OffersNudge;
}(React.Component));
exports.default = OffersNudge;
//# sourceMappingURL=offers_nudge.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/offers/offers_nudge.js
// module id = xBbp
// module chunks = 20 21